import type { IVector3 } from '@seddi/math-v2';

/**
 * Color to string.
 * @param color Color.
 */
export const stringifyColor = (color: IVector3): string => {
  return `${color.x},${color.y},${color.z}`;
};

/**
 * Fabric string with recolor.
 * @param id Fabric ID.
 * @param color Recolor target.
 */
export const getFabricColorId = (id: string, color?: IVector3): string => {
  if (!color) {
    return id;
  }
  return `${id}:${stringifyColor(color)}`;
};
